import React from "react";
import prashant from "../Assets/Images/prashant.jpeg"
import rcbafana from "../Assets/Images/RCBafnaLogo.png"
import nirmal from "../Assets/Images/nirmal.jpeg"
import patilbiotech from "../Assets/Images/patilbiotech.png"
import Neha from "../Assets/Images/neha.png"
import snehal from "../Assets/Images/snehal.png"
import sonali from "../Assets/Images/sonali.png"
import swachh from "../Assets/Images/Swacch .png"
const clientTestimonials = [
  {
    name: "Prashant Book House, Jalgaon",
    role: "Retail Book Store",
    message:
      "Technoweit provided us with a professional and user-friendly website that perfectly represents our bookstore. Their support and execution were excellent.",
    image: prashant,
  },
  {
    name: "RC Bafana Jewellers, Jalgaon",
    role: "Jewellery Business",
    message:
      "We are very satisfied with Technoweit’s work. The website design is elegant, fast, and aligns well with our brand identity.",
    image: rcbafana,
  },
  {
  name: "Swaccha Polymers, Hyderabad, Telangana",
  role: "Plastic Manufacturing Company",
  message:
    "Technoweit delivered a well-structured and professional website for our manufacturing business. The team was responsive, understood our requirements clearly, and delivered on time.",
  image: swachh,
},
  {
    name: "Nirmal Seeds Pvt Ltd, Pachora",
    role: "Agriculture & Seeds Company",
    message:
      "Technoweit delivered a reliable and informative website for our company. Their technical expertise and timely delivery impressed us.",
    image: nirmal,
  },
  {
    name: "Patil Biotech, Jalgaon",
    role: "Biotechnology Company",
    message:
      "Technoweit developed a clean and informative website for our biotech business. The team understood our requirements well and delivered quality work.",
    image:patilbiotech,
  },
];

const studentTestimonials = [
  
  {
    name: "Snehal Shirture",
    role: "Devops Enginner",
    message:
      "The projects and guidance provided here boosted my confidence. Highly recommended for beginners.",
    image: snehal,
  },
  {
    name: "Sonali Chaudhary",
    role: "React Developer",
    message:
      "Excellent training with real-world examples. Concepts like React and APIs became very easy.",
    image:sonali,
  },
  {
    name: "Neha Patil",
    role: "MERN Stack Student",
    message:
      "Technoweit helped me understand full stack development from basics. The teaching style is very clear and practical oriented.",
    image: Neha,
  },
];

const Testimonials = () => {
  return (
    <section className="bg-gray-300 py-16">
      <div className="max-w-7xl mx-auto px-4">

        <div className="mb-20">
          <div className="text-center mb-12">
            <h2 className="text-4xl font-semibold  text-gray-800">Client Testimonials</h2>
            <p className="mt-3 text-gray-600">
              What our clients say about Technoweit
            </p>
          </div>

          <div className="grid lg:grid-cols-3 md:grid-cols-2 grid-cols-1 gap-8">
            {clientTestimonials.map((item, index) => (
              <div
                key={index}
                className="bg-white p-6 rounded-xl shadow-md hover:shadow-xl transition"
              >
                <div className="flex items-center gap-4 mb-4">
                  <img
                    src={item.image}
                    alt={item.name}
                    className="w-14 h-14 rounded-full object-cover"
                  />
                  <div>
                    <h4 className="font-semibold text-lg text-gray-700">
                      {item.name}
                    </h4>
                    <p className="text-sm text-gray-500">{item.role}</p>
                  </div>
                </div>

                <p className="text-gray-700 text-sm leading-relaxed">
                  “{item.message}”
                </p>
              </div>
            ))}
          </div>
        </div>

        <div>
          <div className="text-center mb-12">
            <h2 className="text-4xl font-semibold text-gray-800">Student Testimonials</h2>
            <p className="mt-3 text-gray-600">
              Feedback from our students
            </p>
          </div>

          <div className="grid lg:grid-cols-3 md:grid-cols-2 grid-cols-1 gap-8">
            {studentTestimonials.map((item, index) => (
              <div
                key={index}
                className="bg-white p-6 rounded-xl shadow-md hover:shadow-xl transition"
              >
                <div className="flex items-center gap-4 mb-4">
                  <img
                    src={item.image}
                    alt={item.name}
                    className="w-14 h-14 rounded-full object-cover"
                  />
                  <div>
                    <h4 className="font-semibold text-lg text-gray-700">
                      {item.name}
                    </h4>
                    <p className="text-sm text-gray-500">{item.role}</p>
                  </div>
                </div>

                <p className="text-gray-700 text-sm leading-relaxed">
                  “{item.message}”
                </p>
              </div>
            ))}
          </div>
        </div>

      </div>
    </section>
  );
};

export default Testimonials;
